import { Box } from '@mui/material';
import ProductCard from './ProductCard';

const ProductGrid = ({ products, onProductClick }) => (
  <Box sx={{ display: 'grid', gridTemplateColumns: { xs: 'repeat(2, minmax(0, 1fr))', sm: 'repeat(3, minmax(0, 1fr))' }, gap: 1.25, mt: 1.25 }}>
    {products.map((product, index) => (
      <ProductCard key={product.id || `${product.name}-${index}`} product={product} onClick={onProductClick} />
    ))}
  </Box>
);

export default ProductGrid;